{
  const toggler = document.querySelector('[ada-menu--nav-toggler][aria-controls="main-menu"]')
  
  if (toggler) {
    // Update aria-label based on aria-expanded state
    const updateAriaLabel = () => {
      const isExpanded = toggler.getAttribute('aria-expanded') === 'true'
      toggler.setAttribute('aria-label', isExpanded ? 'Close Main Menu' : 'Open Main Menu')
    }

    // Listen for the custom events dispatched by the ada-menu system
    toggler.addEventListener('main_toggler_opened', updateAriaLabel)
    toggler.addEventListener('main_toggler_closed', updateAriaLabel)

    // Also observe aria-expanded attribute changes directly (as a fallback)
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
          updateAriaLabel()
        }
      })
    })

    observer.observe(toggler, { attributes: true })

    // Set initial state
    updateAriaLabel()
  }
}
